import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss',
    standalone: false
})
export class DashboardComponent implements OnInit {
  title: string = 'Abiomed - TrainingSphere';
  ngOnInit(): void {}
  
  constructor(public Router: Router){}

  rolePlay() {
    this.Router.navigate(['/app-roleplay-profile', { mode: 'roleplay' }], { skipLocationChange: true });
  }

  chat(){
    this.Router.navigate(['/app-abiomed-chat'], { skipLocationChange: true });
  }
  
}
